import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExoStar } from 'src/app/models/ExoStar';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { ToastrService } from 'ngx-toastr';
import { ExoStarService } from 'src/app/Services/ExoStar/exo-star.service'
import { IAttributes } from 'src/app/models/IAttributes';
import { Observable, Subscription, Subscriber } from 'rxjs/Rx';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { EXOAuthTransaction } from 'src/app/models/EXOAuthTransaction';

export interface DialogData {
  status: ExoStar;
  Exogrant: ExoStar;
}

@Component({
  selector: 'app-epcs-finalizegrant',
  templateUrl: './epcs-finalizegrant.component.html',
  styleUrls: ['./epcs-finalizegrant.component.css']
})
export class EpcsFinalizegrantComponent implements OnInit {
  finalizegrantform: FormGroup;
  providerGrantaccess: boolean;
  disableText: boolean = false;
  public grantchk: any;
  lstTokentype: IAttributes[] = [];
  lstattrbutes: IAttributes[] = [];
  Grantdisable: boolean = true;
  public Keys: any;
  sub: Subscription;
  constructor(
    public dialogRef: MatDialogRef<EpcsFinalizegrantComponent>, private toastr: ToastrService, public dialog: MatDialog, private formBuilder: FormBuilder, private ExoStarServices: ExoStarService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.grantchk = data.status;
    // alert(this.grantchk);
    this.Keys = data.Exogrant;


  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.finalizegrantform = this.formBuilder.group({
      tokentype: ['',],
      pwd: ['',],
      otp: [''],
      FinGrant: ['']

    });
    this.getTokens();
  }

  getTokens() {
    this.lstTokentype = [
      { attributeName: 'SOFT' } as IAttributes,
      { attributeName: 'HARD' } as IAttributes,
      { attributeName: 'PUSH' } as IAttributes
    ];
  }

  onSubmit(): void {
    var EpseObjs: ExoStar = this.finalizegrantform.value;
    EpseObjs.loggedInUser = sessionStorage.getItem("userId").toString();
    EpseObjs.providerId = this.Keys.providerId;
    EpseObjs.userId = this.Keys.userId;
    EpseObjs.password = this.finalizegrantform.value.pwd;
    EpseObjs.otp = this.finalizegrantform.value.otp;
    EpseObjs.type = this.finalizegrantform.value.tokentype;
    EpseObjs.facilityId = Number(sessionStorage.getItem("FacilityId").toString());
    this.ExoStarServices.TwoFactorAUthenticationDetails(EpseObjs).subscribe(
      (results: any) => {
        if (EpseObjs.type == 'HARD' || EpseObjs.type == 'SOFT') {
          if (results.transactionStatus == 'SUCCESS' && results.response == 'SUCCESS') {
            this.Grantdisable = false;
            this.toastr.success("You are Authorized.Proceed with grant Access");
          }
          else {
            this.toastr.error(results.response);
            this.Grantdisable = true;
          }

        }
        else {
          if (results.transactionStatus == 'SUCCESS' && results.response == 'ACTIVE') {
            this.checkPusnNotificationStatus(results.transRefId);
          }
          else
            this.toastr.error(results.response);

        }
      }, (err: any) => {
        console.log(err);
      });
  }
  userid: string;
  OnSelectionChange(event) {
    if (event.checked = true) {
      this.providerGrantaccess = true;
    }
    else {
      this.providerGrantaccess = false;
    }
    this.userid = this.Keys.userId;
    this.ExoStarServices.updateExoStarProviderGrantAccessdetails(this.Keys.userId, this.providerGrantaccess).subscribe(
      results => {
        this.toastr.success(results);
        this.dialogRef.close(false);
      }, (err: any) => {
        console.log(err);
      });
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  checkPusnNotificationStatus(transRefId: any) {
    const EpseObjs = new EXOAuthTransaction();
    EpseObjs.facilityId = Number(sessionStorage.getItem("FacilityId").toString());
    EpseObjs.providerId = this.Keys.providerId;
    EpseObjs.otp = transRefId;
    this.sub = Observable.interval(5000)
      .subscribe((val) => { this.checkTransactionStatus(EpseObjs) });
  }
  _result: any;
  checkTransactionStatus(transaction: EXOAuthTransaction) {
    this.ExoStarServices.checkPushTransactionStatus(transaction).subscribe(
      (results: any) => {
        if (results.response == 'APPROVED') {
          this.sub.unsubscribe();
          this.Grantdisable = false;
          this.toastr.success("Transaction Approved.Proceed with grant Access");
        }
        else if (results.response == 'DENIED') {
          this.sub.unsubscribe();
          this.toastr.success("Transaction Denied. Please try again");
        }
        else if (results.response == 'EXPIRED') {
          this.sub.unsubscribe();
          this.toastr.success("Transaction Expired.Please try again");
        }

      });
  }
  onTokenChange(event,type: string) {
    if (event.source.selected == true) {
    if (type === 'SOFT') {
      this.disableText = true;
    }
    else {
      this.disableText = false;
    }
  }
  }

}
